module.exports = __webpack_public_path__ + "kehuduan.05973cc8.jpg";